import { useUser } from "hooks/use-user";
import DispatcherAllTicketsList from "./dispatcherTickets/all-tickets-list";
import CCAAllTicketsList from "./callCenterAgentTickets/all-tickets-list";
import { isCallCenterAgent } from "./utils";

export default function AllTicketsList() {
  const user = useUser();
  const isCCA = isCallCenterAgent(user);

  if (isCCA) {
    return <CCAAllTicketsList />;
  }
  return <DispatcherAllTicketsList />;
}
